import { all } from "redux-saga/effects";
import { hocKyDangKySaga } from "./hocKyDangKySaga";
import { lopTinChiSaga } from "./lopTinChiSaga";
import { lopTinChiKetQuaSaga } from "./lopTinChiKetQuaSaga";
import { danhSachLopTinChiSaga } from "./danhSachLopTinChiSaga";
import { danhSachMoMon } from "./danhSachMoMonSaga";

export default function* lopTinChiSagaWrapper() {
  yield all([
    hocKyDangKySaga(),
    lopTinChiSaga(),
    lopTinChiKetQuaSaga(),
    danhSachLopTinChiSaga(),
    danhSachMoMon(),
  ]);
}
